{
	"title": "Faktury",
	"buttonShowMoreInvoicesTitle": "Pokaż więcej faktur",
	"invoicesTableHeaders": {
		"date": "Data",
		"invoiceNumber": "Numer faktury",
		"deliveredQuantity": "Dostarczona ilość",
		"bundledCarbonSavings": "Zbundlowane redukcje emisji CO\u2082",
		"transactionId": "ID transakcji"
	},
	"errorMessage": "Nie udało się wczytać faktur"
}
